function showFilters() {
  if ($('.filters').length > 0) {
    const mobileBreakpoint = 1024;
    const maxWidthFilterText = 225;
    const filter = $('.toggle-filter');
    const filterText = $('.toggle-filter-text');
    const filterContainer = $('.category-filter > div');

    $('.toggle-filter').on('click', function() {
      $(this).toggleClass('rotate-arrow');
      $('.filters').toggleClass('show-filters');
      if ($('.filters').hasClass('show-filters')) {
        $('.overlay').addClass('visible');
      } else {
        $('.overlay').removeClass('visible');
      }

      if ($(window).width() < mobileBreakpoint) {
        $(this).closest('section').toggleClass('primary');
      }
    });

    $('.filters a').on('click', function(e) {
      e.preventDefault();
      filter.toggleClass('rotate-arrow');
      $('.filters li').removeClass('selected');
      $(this).parent().addClass('selected');
      $(this).closest('.filters').removeClass('show-filters');
      $('.overlay').removeClass('visible');

      $('.toggle-filter-text').text($(this).data('label'));
      getLatestArticles($(this).data('category'));

      if (filterText.width() > maxWidthFilterText) {
        filterText.parent().addClass('new-line');
        filterContainer.addClass('no-margin');
      } else {
        filterText.parent().removeClass('new-line');
        filterContainer.removeClass('no-margin');
      }
    });

    $('.overlay').on('click', function(e) {
      if (!$(e.target).closest('.category-filter').length > 0) {
        $('.filters').removeClass('show-filters');
        $('.toggle-filter').toggleClass('rotate-arrow');
        $('.overlay').removeClass('visible');
      }
    });
  }
}

function getLatestArticles(category) {
  $.ajax({
    type: 'GET',
    url: jQuery('.category-filters').data('filter'),
    dataType: 'html',
    data: {
      action: 'latest_articles',
      category: category,
    },
    success: function (data) {
      $('.recent-articles-results').html(data);
    },
  });
}

export default { showFilters };



// WEBPACK FOOTER //
// ./src/js/custom/category-filters.js